<script setup lang="ts">
import { watch } from 'vue';

export interface NavBarItem {
  id: string;
  title: string;
  total: number;
  selected: boolean;
}
interface Props {
  items: NavBarItem[];
  showQuantities: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  selected: [value: string];
}>();

let navBarItems = props.items;

watch(
  () => props.items,
  function () {
    navBarItems = props.items;
  },
);

function selectItem(item: NavBarItem) {
  navBarItems.map((navBarItem) => (navBarItem.selected = navBarItem.id === item.id));
  emit('selected', item.id);
}
</script>
<template>
  <nav class="nav-bar">
    <ul class="nav-bar-nav">
      <li
        v-for="item in navBarItems"
        :key="item.id"
        :class="[{ selected: item.selected }]"
        class="nav-item"
        v-on:click="selectItem(item)">
        <div class="title">
          <p>
            {{ item.title }}
          </p>
          <span v-if="showQuantities">{{ '( ' + item.total + ' )' }}</span>
        </div>
      </li>
    </ul>
  </nav>
</template>
